import { ApiBase } from '@fg-services/api/models/api-base';
import {
  IIncidentReport,
  IncidentReportChanges,
  IncidentReportFilters,
  IncidentReportsLastKey,
  IncidentReportsOpenCount,
  IncidentReportsResponse
} from '@fg-types/incident-report';

export class IncidentReportsApi extends ApiBase {
  model = 'IncidentReports';

  // Admin view: every report for the event, so reporterId is never sent
  fetchReports(
    conventionId: string,
    filters: IncidentReportFilters = {},
    lastKey?: IncidentReportsLastKey
  ) {
    const params = this.setParams({
      conventionId,
      // unset filters are left out of the query, never sent as empty strings
      category: filters.category || undefined,
      priority: filters.priority || undefined,
      status: filters.status || undefined,
      // object cursors are JSON-encoded, the same way the mobile app's axios client sends them
      lastKey: typeof lastKey === 'object' && lastKey ? JSON.stringify(lastKey) : lastKey || undefined
    });
    return this.http.get<IncidentReportsResponse>(`${this.modelBase}/fetch-reports`, { params });
  }

  getOpenCount(conventionId: string) {
    return this.http.get<IncidentReportsOpenCount>(`${this.modelBase}/open-count`, {
      params: this.setParams({ conventionId })
    });
  }

  updateStatus(id: string, changes: IncidentReportChanges) {
    return this.http.patch<IIncidentReport>(`${this.modelBase}/${id}/status`, changes);
  }
}
